import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from "react";
import { useProfilePageFollowingQuery } from "sprout-graphql";
import { useParams } from "react-router-dom";
import { TabList, Tab } from "sprout-ui-dom/dist/Tabs";
import useLoadingProgress from "@sprout/hooks/dist/useLoadingProgress";
import { Glitch, NotFound } from "@sprout/views";
import getFullName from "@sprout/client-lib/dist/getFullName";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { Page } from "@sprout/client-layout";
import styled from "styled-components";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import ProfilePageFollowingPeople from "./ProfilePageFollowingPeople";
import ProfilePageFollowingTopics from "./ProfilePageFollowingTopics";
const ProfilePageFollowingTabList = styled(TabList)`
  justify-content: center;
`;
const ProfilePageFollowing = ()=>{
    const { username  } = useParams();
    const { loading , data , error  } = useProfilePageFollowingQuery({
        variables: {
            username
        },
        fetchPolicy: "cache-and-network"
    });
    const user = data === null || data === void 0 ? void 0 : data.user;
    const currentUser = useCurrentUser();
    useLoadingProgress(loading && !user);
    const [index, setIndex] = useState(0);
    const handleChange = useCallback((_, nextIndex)=>{
        setIndex(nextIndex);
    }, []);
    useActionRegistryGlobalHandler("PREVIOUS", useCallback(()=>{
        setIndex(0);
        return true;
    }, []));
    useActionRegistryGlobalHandler("NEXT", useCallback(()=>{
        setIndex(1);
        return true;
    }, []));
    if (loading && !data) return null;
    if (error) return /*#__PURE__*/ _jsx(Glitch, {
        error: error
    });
    if (!user) return /*#__PURE__*/ _jsx(NotFound, {});
    const fullName = getFullName(user);
    const isCurrentUser = user.id === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
    return /*#__PURE__*/ _jsxs(Page, {
        variant: "shadow",
        title: isCurrentUser ? "You follow" : `${fullName || username} follows`,
        children: [
            /*#__PURE__*/ _jsxs(ProfilePageFollowingTabList, {
                index: index,
                onChange: handleChange,
                children: [
                    /*#__PURE__*/ _jsx(Tab, {
                        children: "People"
                    }),
                    /*#__PURE__*/ _jsx(Tab, {
                        children: "Trees"
                    })
                ]
            }),
            index === 0 && /*#__PURE__*/ _jsx(ProfilePageFollowingPeople, {
                fullName: fullName
            }),
            index === 1 && /*#__PURE__*/ _jsx(ProfilePageFollowingTopics, {
                fullName: fullName
            })
        ]
    });
};
export default ProfilePageFollowing;
